import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom"; // Importowanie hooka do nawigacji
import { useTranslation } from "react-i18next";
import searchIcon from "./../../media/search-icon.svg";
import "./../../styleSheet/main/admin/announcements/announcements.css";
import { NavLink } from "react-router-dom";
import { FLASK_URL } from "../../AuthContext";
import axios from "axios";
import carIcon from "./../../media/announcements/car.svg";
import computerIcon from "./../../media/announcements/computer.svg";
import documentsIcon from "./../../media/announcements/documents.svg";
import exclamationIcon from "./../../media/announcements/exclamation.svg";
import familyIcon from "./../../media/announcements/family.svg";
import planeIcon from "./../../media/announcements/plane.svg";
import foodIcon from "./../../media/announcements/food.svg";
import plantIcon from "./../../media/announcements/plant.svg";
import questionIcon from "./../../media/announcements/question.svg";
import starIcon from "./../../media/announcements/star.svg";
import toolsIcon from "./../../media/announcements/tools.svg";
import peopleIcon from "./../../media/announcements/people.svg";
import { useNotification } from "../../components/NotificationContext";
import Logger from "../../utils/Logger";
import deleteButtonIcon from "./../../media/delete-button.svg";
import trashButtonIcon from "./../../media/trash-button.svg";
import editButtonIcon from "./../../media/edit-button.svg";
import { createPortal } from "react-dom"; // Dodajemy import createPortal
import httpClient from "../../services/httpClient";
import { useAuth } from "../../AuthContext";
import { LoadingComponent } from "../../App";
import RenderedHtml from "../../components/renderedHtml";

function Announcements() {
  const { t } = useTranslation();
  const [activeIndexes, setActiveIndexes] = useState([0, 1, 2]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchBy, setSearchBy] = useState("title");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true); // Stan ładowania
  const [error, setError] = useState(null);
  const [nextCursor, setNextCursor] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);
  const dropdownRef = useRef(null);
  // const { showNotification } = useNotification();
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [announcementToDelete, setAnnouncementToDelete] = useState(null);
  const [announcementTitle, setAnnouncementTitle] = useState("");
  const { userData } = useAuth();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1350);

  const ICONS = {
    car: carIcon,
    computer: computerIcon,
    documents: documentsIcon,
    exclamation: exclamationIcon,
    family: familyIcon,
    plane: planeIcon,
    food: foodIcon,
    plant: plantIcon,
    question: questionIcon,
    star: starIcon,
    tools: toolsIcon,
    people: peopleIcon,
  };

  // Sprawdź czy użytkownik ma uprawnienia administratora
  const isAdmin = () => {
    return (
      userData?.userRole === "admin" || userData?.userRole === "hr-manager"
    );
  };

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await httpClient.get("/Announcements/paged", {
          withAuth: true,
        });

        setAnnouncements(response.data.announcements);
        setNextCursor(response.data.next);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchAnnouncements();
  }, []);

  const toggleDetails = (index) => {
    if (activeIndexes.includes(index)) {
      setActiveIndexes(activeIndexes.filter((i) => i !== index));
    } else {
      setActiveIndexes([...activeIndexes, index]);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearchByChange = (criterion) => {
    setSearchBy(criterion);
    setSearchTerm("");
    setIsDropdownOpen(false);
  };

  const handleSearchClick = () => {
    const filtered = announcements.filter((announcement) => {
      const value =
        searchBy === "title"
          ? announcement.title
          : announcement.createdAt
            ? new Date(announcement.createdAt).toLocaleDateString("pl-PL")
            : "";
      return value && searchTerm
        ? value.toLowerCase().includes(searchTerm.toLowerCase())
        : false;
    });
    Logger.log("Wyniki wyszukiwania:", filtered);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDelete = async (id, title) => {
    setAnnouncementToDelete(id);
    setAnnouncementTitle(title);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await httpClient.delete(`/announcements/${announcementToDelete}`, {
        withAuth: true,
      });

      setAnnouncements((prev) =>
        prev.filter((announcement) => announcement.id !== announcementToDelete),
      );
      // showNotification("Ogłoszenie zostało pomyślnie usunięte.", "success");
    } catch (err) {
      Logger.error("Błąd podczas usuwania ogłoszenia:", err);
      // showNotification("Nie udało się usunąć ogłoszenia.", "error");
    } finally {
      setShowDeleteModal(false);
      setAnnouncementToDelete(null);
    }
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setAnnouncementToDelete(null);
  };

  const loadMoreAnnouncements = async () => {
    if (!nextCursor || loadingMore) return;

    setLoadingMore(true);
    try {
      const response = await httpClient.get(
        `/Announcements/paged?next=${nextCursor}`,
        {
          withAuth: true,
        },
      );

      setAnnouncements((prev) => [...prev, ...response.data.announcements]);
      setNextCursor(response.data.next);
    } catch (err) {
      Logger.error("Błąd podczas ładowania kolejnych ogłoszeń:", err);
      setError(err.message);
    } finally {
      setLoadingMore(false);
    }
  };

  // Adjust search and filtering to use fields.title and fields.details
  const filteredAnnouncements = announcements.filter((announcement) => {
    const value =
      searchBy === "title"
        ? announcement.title
        : announcement.createdAt
          ? new Date(announcement.createdAt).toLocaleDateString("pl-PL")
          : "";
    return value && searchTerm
      ? value.toLowerCase().includes(searchTerm.toLowerCase())
      : true;
  });

  Logger.log(filteredAnnouncements);

  // Dodajemy funkcję do renderowania modalu przez portal
  const renderDeleteModal = () => {
    if (!showDeleteModal) return null;

    return createPortal(
      <div className="confirmation-overlay">
        <div className="confirmation-box">
          <img
            className="close-button"
            src={deleteButtonIcon}
            alt="Close"
            onClick={cancelDelete}
          />
          <div className="areYouSure">
            <p>
              {t("announcements.confirmDelete")}{" "}
              <strong>{announcementTitle}</strong>?
            </p>
          </div>
          <div className="confirmation-buttons">
            <button onClick={confirmDelete}>{t("common.yes")}</button>
            <button onClick={cancelDelete}>{t("common.no")}</button>
          </div>
        </div>
      </div>,
      document.body, // Renderujemy bezpośrednio w body
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1350);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={`announcements-wrapper ${loading ? "loading" : ""}`}>
      <div className="header">
        <div className="ogloszenia">{t("announcements.title")}</div>
        {/* Przycisk "Stwórz nowe ogłoszenie" tylko dla administratorów */}
        {isAdmin() && (
          <NavLink
            className="create-button"
            to="/administrator/aktualnosci/nowe-ogloszenie"
          >
            {t("announcements.createNew")}
          </NavLink>
        )}
        <div className="searching">
          {isSmallScreen ? (
            <>
              <input
                type="text"
                placeholder={t("announcements.searchByContent")}
                value={searchTerm}
                onChange={handleSearchChange}
              />
              <div
                className="search-icon"
                style={{ backgroundImage: `url(${searchIcon})` }}
                onClick={handleSearchClick}
              ></div>
            </>
          ) : (
            <>
              <input
                type="text"
                placeholder={
          searchBy === "title"
            ? t("documentList.searchByTitle")
            : t("documentList.searchByDate")
        }
                value={searchTerm}
                onChange={handleSearchChange}
              />
              <div
                className="search-icon"
                style={{ backgroundImage: `url(${searchIcon})` }}
                onClick={handleSearchClick}
              ></div>
              <div
                className={`dropdown ${isDropdownOpen ? "open" : ""}`}
                ref={dropdownRef}
              >
                <button className="search-toggle-btn" onClick={toggleDropdown}>
                  {searchBy === "title"
                    ? t("announcements.titleLabel")
                    : t("common.date", "Data")}
                </button>
                <div className="dropdown-content">
                  <button
                    className="dropdown-item"
                    onClick={() => handleSearchByChange("title")}
                  >
                    {t("announcements.titleLabel")}
                  </button>
                  <button
                    className="dropdown-item"
                    onClick={() => handleSearchByChange("date")}
                  >
                    {t("common.date", "Data")}
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {loading ? (
        <LoadingComponent />
      ) : error ? (
        <div className="error-message">
          {t("common.error")}: {error}
        </div>
      ) : (
        <div className="announcements-container">
          {filteredAnnouncements.map((announcement, index) => (
            <div
              key={`${announcement.id}-${index}`}
              className="announcement-item"
            >
              <div
                className="announcement-title"
                onClick={() => toggleDetails(index)}
              >
                <div className="announcement-icon">
                  <img
                    src={ICONS[announcement.icon] || starIcon}
                    alt="Ikona ogłoszenia"
                  />
                </div>
                {announcement.title}
                {/* Przyciski "Edytuj" i "Usuń" tylko dla administratorów */}
                {isAdmin() && (
                  <div className="admin-buttons">
                    <button
                      className="edit-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(
                          `/administrator/aktualnosci/edytuj/${announcement.id}`,
                        );
                      }}
                    >
                      <img
                        src={editButtonIcon}
                        alt="Edytuj"
                        style={{ width: 38, height: 38 }}
                      />
                    </button>
                    <button
                      className="delete-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        Logger.log(announcement);
                        handleDelete(announcement.id, announcement.title);
                      }}
                    >
                      <img
                        src={trashButtonIcon}
                        alt="Usuń"
                        style={{ width: 38, height: 38 }}
                      />
                    </button>
                  </div>
                )}
              </div>
              <div
                className={`announcement-details ${
                  activeIndexes.includes(index) ? "active" : ""
                }`}
              >
                <RenderedHtml html={announcement.details} />
                <div className="announcement-date">
                  {announcement.createdBy},{" "}
                  {new Date(announcement.createdAt).toLocaleDateString("pl-PL")}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {!loading && !error && (
        <div className="load-more-container">
          {nextCursor ? (
            <button
              className="load-more-button"
              onClick={loadMoreAnnouncements}
              disabled={loadingMore}
            >
              {loadingMore ? t("common.loading") : t("announcements.loadMore")}
            </button>
          ) : (
            announcements.length > 0 && (
              <p className="all-loaded-message">
                {t("announcements.allLoaded")}
              </p>
            )
          )}
        </div>
      )}

      {renderDeleteModal()}
    </div>
  );
}

export default Announcements;
